import * as React from 'react';
import './ToolBar.scss';
import monthlyStatementService from 'src/services/MonthlyStatement';
import { downloadFile } from 'src/utils/downloadHelper';
import LocaleFormating from 'src/translation/localeFormating';
import { number } from 'prop-types';
import { env } from 'src/shared/env';
import i18n from 'src/translation/i18n';

export interface IToolBarProps {
  currentMonth: number;
  t?: any;
}

const ToolBar: React.SFC<IToolBarProps> = props => {
  const { t } = props;
  function downloadInvoices(currentMonth: number) {
    monthlyStatementService
      .downloadStatement(currentMonth)
      .then((response: any) => {
        downloadFile(
          response.data,
          `statement-${currentMonth}-${LocaleFormating.getNowDate('short')}.pdf`
        );
      });
  }

  function handleNavigation() {
    window.location.assign(
      `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/Reliable_Parts_Canada_Electronic_Payment.pdf`
    );
  }

  const language = i18n.language.split('-')[0];

  return (
    <div className="rp-account-statement--tool-bar-download-container">
      {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
        <div className="rp-account-statement--tool-bar-eft-download">
          <a
            target="_blank"
            href={
              language === 'fr'
                ? `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/Reliable_Parts_Canada_Electronic_Payment_Information_French.pdf`
                : `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/Reliable_Parts_Canada_Electronic_Payment_Information.pdf`
            }
          >
            {t('accountMonthlyStatements.makeYourPaymentsViaLink')}
          </a>
        </div>
      ) : (
        ''
      )}
      <button
        className="rp-account-statement--tool-bar-download primary-button"
        onClick={() => {
          downloadInvoices(props.currentMonth);
        }}
      >
        {t('accountMonthlyStatements.downloadStatementActionTxt')}
      </button>
    </div>
  );
};

export default ToolBar;
